import React from "react";
import CommissionReport from "../components/CommissionReport";
import { useProfile } from "../context/ProfileContext";

const TaxCommission = () => {
  const { profile, assignModule } = useProfile();
  const isNewType = profile?.employeeType === "new";
  const taxModule = isNewType && assignModule?.taxesCommission?.enabled ? assignModule.taxesCommission : null;

  if (isNewType && !taxModule) {
    return (
      <div className="p-6">
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">You do not have access to the Tax & Commission module.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Tax & Commission</h1>
        <p className="mt-2 text-sm text-gray-600">
          View and manage commission reports and tax information
        </p>
      </div>
      <CommissionReport />
    </div>
  );
};

export default TaxCommission;
